<template src="./ManagedMatch.html" />

<script>
import mixins from "@/Mixins.js"

export default {
  name: "ManagedMatch",

  mixins: [mixins],
  
  data() {
    return {
      selected: "",
      searchPatient: "",
      popupMatchDoctors: false,
      docMatchList: [],
      docMatchListCache: [],
      docMatchListPaginated: [],
      indicatedDoctor: {},
      scheduleId: 0,
      appointments: [],
      windoWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      isProject: false,
      currentxDocMatchList: 1,
      numPagesDocMatchList: 0,
      paginationDocMatchList: false,
      matchPageSize: 5
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  mounted () {
    this.isProject = this.$session.get("isProject")
      ? this.$session.get("isProject")
      : false
    this.getAppointments()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  watch: {
    currentx () {
      this.changePagination()
    },
    currentxDocMatchList () {
      this.changePaginationDocsMatchList()
    },
  },
  methods: {
    getAppointments() {
      const page = this.currentx - 1;

      this.axios.get(
        `${this.$store.state.filooServer}consultant/appointments?page=${page}&search=${this.searchPatient}&size=10&sort=createDate,desc&status=WAITING_MATCH`,
          { headers: { Authorization: this.$session.get("bearer") }}
        )
        .then(({ status, data: { content, totalPages } }) => {
          if (status === 200) {
            this.appointments = content
            this.numPages = totalPages
            this.pagination = this.numPages > 1
          }
        })
        .finally(() => this.$vs.loading.close())
    },
    handleSelected(tr) {
      this.$vs.loading();
      this.indicatedDoctor = {};
      this.scheduleId = tr.scheduleId;

      if (tr.clinic && tr.clinic.id) {
        this.axios.get(
          `${this.$store.state.filooServer}clinic-doctors/doctors/${tr.scheduleId}/clinic/${tr.clinic.id}`,
          { headers: { Authorization: this.$session.get("bearer") }}
        )
          .then(({status, data}) => {
            if (status === 200) {
              this.docMatchList = data.filter(
                (clinicDoctor) =>
                  (clinicDoctor.doctor.id === tr.doctor.id) ||
                  (
                    clinicDoctor.doctor.id != tr.doctor.id &&
                    clinicDoctor.day.price <= tr.price &&
                    clinicDoctor.attendanceType === tr.attendanceType
                  )
              )

              this.docMatchListCache = this.docMatchList;
              this.numPagesDocMatchList = Math.ceil(this.docMatchList.length / 10);
              this.paginationDocMatchList = this.numPagesDocMatchList > 1;
              this.openMatchDocList();

              this.$vs.loading.close();
            }
          })
          .catch(() => {
            this.showNotifyWarning(
              "Não foi possível listar médico da clinica",
              4000
            );
            this.popupMatchDoctors = false
          })
          .finally(() => this.$vs.loading.close());
      } else {
        this.axios.get(
          `${this.$store.state.filooServer}consultant/appointmentsDocList?scheduleId=${tr.scheduleId}`,
          { headers: { Authorization: this.$session.get("bearer") }}
        )
          .then(({ status, data: { content }}) => {
            if (status === 200) {
              this.docMatchList = content
              this.docMatchListCache = this.docMatchList
              this.numPagesDocMatchList = Math.ceil(this.docMatchList.length / 10)
              this.paginationDocMatchList = this.numPagesDocMatchList > 1
              this.openMatchDocList()
              this.$vs.loading.close()
            }
          })
          .catch(() => (this.popupMatchDoctors = false))
      }

      this.axios.get(
        `${this.$store.state.filooServer}consultant/get-indicated-doctor?scheduleId=${tr.scheduleId}`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.indicatedDoctor = data;

            if (this.indicatedDoctor.indicatedDoctorId) {
              this.indicatedDoctor.indicatedDoctorId = parseInt(this.indicatedDoctor.indicatedDoctorId)
            }
          }
        });
    },
    openMatchDocList() {
      this.popupMatchDoctors = true;
      this.changePaginationDocsMatchList();
    },

    setSchedule(tr) {
      this.$vs.loading({ text: "Agendando" })
      this.axios.post(
        `${this.$store.state.filooServer}consultant/createDocSchedule/${this.scheduleId}`,
        tr,
        { headers: { Authorization: this.$session.get("bearer") } }
      )
        .then(({ status, data }) => {
          if (status === 201) {
            if (data >= 0) {
              this.$vs.notify({
                title: "Ops.",
                text: "Cliente sem saldo.",
                color: "warning",
                icon: "error",
                position: "top-right",
              });
            } else {
              this.$swal("Sucesso", "Consulta vinculada com sucesso.", "success");
            }

            this.popupMatchDoctors = false
            this.$vs.loading.close()
            this.getAppointments()
          }
        })
        .catch(() => {
          this.$swal(
            "Atenção",
            "Não foi possível vincular a consulta, contacte o administrador do sistema."
          )
          this.$vs.loading.close()
          this.popupMatchDoctors = false
        })
    },
    getPeriodo(periodo) {
      let start = periodo.slice(11, 13)
      let end = periodo.slice(19, 21)

      if (start >= 12) {
        return "Tarde"
      }
      if (end <= 12) {
        return "Manhã"
      }
      return "Integral"
    },
    changePagination() {
      this.getAppointments()
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    changeSearchPatient() {
      this.currentx = 0
      this.$vs.loading()
      this.getAppointments()
    },
    handleSearch(search) {
      this.currentxDocMatchList = 1
      this.docMatchList = this.docMatchListCache
        .filter(({ doctor }) => search && doctor.name.includes(search) || !search)

      this.numPagesDocMatchList = Math.ceil(this.docMatchList.length / this.matchPageSize)
      this.paginationDocMatchList = this.numPagesDocMatchList > 1
      this.changePaginationDocsMatchList()
    },
    changePaginationDocsMatchList() {
      this.docMatchListPaginated = this.docMatchList.slice(
        (this.currentxDocMatchList - 1) * 5,
        this.currentxDocMatchList * 5
      )
    },
  },
};
</script>

<style src="./ManagedMatch.css" />
